(function () {
  'use strict';

  function initCard(card) {
    if (card._plInit) return;
    card._plInit = true;

    var productUrl = card.dataset.plUrl;
    var gallery = card.querySelector('[data-pl-gallery]');

    if (gallery) {
      var track = gallery.querySelector('[data-pl-track]');
      var slides = track ? track.querySelectorAll('.pl-gallery__slide') : [];
      var prev = gallery.querySelector('[data-pl-prev]');
      var next = gallery.querySelector('[data-pl-next]');
      var dots = gallery.querySelectorAll('[data-pl-dot]');
      var cur = 0;

      function goTo(idx) {
        cur = (idx + slides.length) % slides.length;
        track.style.transform = 'translateX(-' + (cur * 100) + '%)';
        dots.forEach(function(d, i) { d.classList.toggle('is-active', i === cur); });
      }

      if (slides.length > 1) {
        if (prev) prev.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); goTo(cur - 1); });
        if (next) next.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); goTo(cur + 1); });
        dots.forEach(function(dot) {
          dot.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); goTo(+dot.dataset.plDot); });
        });
        var sx = 0;
        gallery.addEventListener('touchstart', function(e) { sx = e.touches[0].clientX; }, { passive: true });
        gallery.addEventListener('touchend', function(e) {
          var dx = e.changedTouches[0].clientX - sx;
          if (Math.abs(dx) > 40) goTo(dx < 0 ? cur + 1 : cur - 1);
        }, { passive: true });
      }
    }

    if (productUrl) {
      card.style.cursor = 'pointer';
      card.addEventListener('click', function(e) {
        if (e.target.closest('button, a')) return;
        window.location.href = productUrl;
      });
    }

    var qBtn = card.querySelector('.pl-quickadd__btn:not(.pl-quickadd__btn--soldout)');
    if (!qBtn) return;

    qBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var variantId = qBtn.dataset.variantId;
      if (!variantId) return;
      var originalHTML = qBtn.innerHTML;
      qBtn.disabled = true;
      qBtn.innerHTML = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function(res) { if (!res.ok) throw new Error(); return res.json(); })
      .then(function() {
        qBtn.innerHTML = '✓ Added!';
        qBtn.style.background = '#1a7a4a';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('theme:cart:open', { bubbles: true }));
        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            document.querySelectorAll('[data-cart-count], .cart-count, .cart__count')
              .forEach(function(el) { el.textContent = cart.item_count; });
          });
        setTimeout(function() { qBtn.disabled = false; qBtn.style.background = ''; qBtn.innerHTML = originalHTML; }, 2200);
      })
      .catch(function() {
        qBtn.innerHTML = 'Error — retry';
        qBtn.style.background = '#c0392b';
        setTimeout(function() { qBtn.disabled = false; qBtn.style.background = ''; qBtn.innerHTML = originalHTML; }, 2000);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-pl-card]').forEach(initCard);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', initAll)
    : initAll();

  document.addEventListener('shopify:section:load', initAll);

  var observer = new MutationObserver(function() {
    document.querySelectorAll('[data-pl-card]:not([data-pl-init])').forEach(function(card) {
      card.setAttribute('data-pl-init', 'true');
      initCard(card);
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();